import React from "react";
import withIconComponent from "../withIconComponent";

var Search = function Search() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 22l-5.6-5.6",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 1 0 0 18 9 9 0 1 0 0-18z"
  }));
};

export default withIconComponent("UiSearch", false)(Search);